var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":'/player/'+_vm.$route.params.boardName+'/'+_vm.$route.params.boardId+'/'+_vm.name}},[_c('b-badge',{staticClass:"mr-1 player",attrs:{"variant":"info"}},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }